<script>
  import { MenuItem } from '@commercebear/components/Menu';
  import Tooltip from '@commercebear/components/Tooltip';
  import Icon from '@commercebear/components/Icon';

  export let list;

  export let org;
  export let deactivated = false;
  export let current = false;
  export let testid;
</script>

<MenuItem on:click {list} value={org.id} {testid}>
  <span class:current class:deactivated>
    {org.name}
    {#if current}
      <Icon icon='check'/>
    {/if}
    {#if deactivated}
      <Tooltip let:tooltip>
        <svelte:fragment slot='tooltip'>
          This organization is currently deactivated.
        </svelte:fragment>
        <Icon icon='person_off' {tooltip} />
      </Tooltip>
    {/if}
  </span>
</MenuItem>

<style lang='postcss'>
  span {
    font: var(--font--outfit-16);
    color: var(--color--default--text);
    
    &.deactivated, &.current {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      gap: 19.5px;
    }

    &.current {
      font: var(--font--outfit-title-16);

      --Icon--color: var(--color--green);
    }

    &.deactivated {
      color: var(--color--orange-70);
    }
  }
</style>
